import React from 'react'

export default () => (
    <div>
		Activity
	</div>
)